import { labels } from './labels'
import { messages } from './messages'

const translations = {
    fa: {
        locale: 'fa',
        messages: Object.assign(labels, messages)
    }
}

export default translations